function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M24.6868 12.2072C25.14 11.7087 25.0962 10.9448 24.5891 10.5013L13.4163 0.725047C12.9091 0.281559 12.0961 0.290849 11.5996 0.74599L0.388821 11.0226C-0.107637 11.4777 -0.132003 12.2406 0.334872 12.7259L0.615943 13.0187C1.08225 13.504 1.83598 13.5618 2.29837 13.1475L3.13621 12.3972V23.3819C3.13621 24.0558 3.68229 24.6014 4.35576 24.6014H8.72576C9.39922 24.6014 9.94531 24.0558 9.94531 23.3819V15.697H15.5193V23.3819C15.5096 24.0553 15.9915 24.6009 16.6649 24.6009H21.296C21.9695 24.6009 22.5156 24.0553 22.5156 23.3814V12.5519C22.5156 12.5519 22.747 12.7546 23.0325 13.0055C23.3175 13.256 23.916 13.0552 24.3692 12.5563L24.6868 12.2072Z",
  fill: "#242424",
  fillOpacity: 1
});

var SvgHomeIcon = function SvgHomeIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgHomeIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/homeIcon.e35e9fca.svg";
export { ForwardRef as ReactComponent };